import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationSummaryStudents(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/inadimplencia/students/', {params});
  return data;
}

type QueryFnType = typeof getConsolidationSummaryStudents;

function useConsolidationSummaryStudents(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-summary-students', params],
    queryFn: () => getConsolidationSummaryStudents(params),
  });
}

export { getConsolidationSummaryStudents, useConsolidationSummaryStudents };
